document.addEventListener("DOMContentLoaded", () => {

  const cards = document.querySelectorAll(".related-product-card");

  cards.forEach((card) => {

    const button = card.querySelector(".related-product-add");
    const sizes = card.querySelectorAll(".related-product-size");

    if (!button) return;

    sizes.forEach((size) => {

      size.addEventListener("click", () => {

        if (size.classList.contains("disabled")) return;

        sizes.forEach((s) => s.classList.remove("active"));

        size.classList.add("active");

        button.dataset.variantId = size.dataset.variantId;

      });

    });

    button.addEventListener("click", () => {

      button.disabled = true;

      button.innerHTML = "Adding...";

      fetch("/cart/add.js", {

        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },

        body: JSON.stringify({

          id: button.dataset.variantId,

          quantity: 1

        })

      })

      .then((response) => response.json())

      .then(() => {

        button.innerHTML = "✓ Added";

        button.classList.add("added");
                if (window.CartDrawer) {
          const cartDrawer = document.querySelector("cart-drawer");

          if (cartDrawer) {
            cartDrawer.renderContents(response);
          }
        }

        document.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true
          })
        );

        setTimeout(() => {

          button.disabled = false;
          button.classList.remove("added");
          button.innerHTML = "Add To Cart";

        }, 1800);

      })

      .catch(() => {

        button.disabled = false;

        button.innerHTML = "Try Again";

      });

    });

  });

});
/* ==========================================
   RELATED PRODUCTS SLIDER
========================================== */

document.addEventListener("DOMContentLoaded", () => {

  const slider = document.querySelector(".related-products-pro__grid");
  const prev = document.querySelector(".related-products-arrow.prev");
  const next = document.querySelector(".related-products-arrow.next");

  if (!slider || !prev || !next) return;

  const getScrollAmount = () => {
    const card = slider.querySelector(".related-product-card");
    return card ? card.offsetWidth + 24 : 320;
  };

  prev.addEventListener("click", () => {

    slider.scrollBy({
      left: -getScrollAmount(),
      behavior: "smooth"
    });

  });

  next.addEventListener("click", () => {

    slider.scrollBy({
      left: getScrollAmount(),
      behavior: "smooth"
    });

  });

});